import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslationModule } from 'src/app/i18n';

@Component({
  selector: 'app-images-modal',
  templateUrl: './image-modal.component.html',
  styleUrls: ['./image-modal.component .scss'],
  imports: [CommonModule, TranslationModule, MatTooltipModule],
})
export class ImageModalComponent {
  //#region properties

  image: any = '';
  imageUrl: string = '';
  imageName: string = '';
  imageClass: string = '';
  currentIndex: number;
  isNextImageBtnDisable: boolean = false;
  isPreviousImageBtnDisable: boolean = false;
  type: string;
  myImg: any;

  //#endregion

  constructor(
    private dialogRef: MatDialogRef<ImageModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.imageUrl = data.image;
  }

  zoomIn() {
    let myImg = document.getElementById('map');
    let currWidth = myImg.clientWidth;
    if (currWidth == 12500) return false;
    else {
      myImg.style.width = currWidth + 100 + 'px';
    }
  }

  zoomOut() {
    let myImg = document.getElementById('map');
    let currWidth = myImg.clientWidth;
    if (currWidth == 100) return false;
    else {
      myImg.style.width = currWidth - 100 + 'px';
    }
  }

  onModalClick(event: MouseEvent) {
    const targetElement = event.target as HTMLElement;

    if (
      !targetElement.closest('img') &&
      !targetElement.closest('button') &&
      !targetElement.closest('.mdi-close')
    )
      this.onClose();
  }

  /** close modal*/
  onClose() {
    this.dialogRef.close();
  }
}
